import axios from 'axios';

const normalizeUrl = (value) => {
  if (!value) return '';
  return String(value).trim().replace(/^['"]|['"]$/g, '').replace(/\/+$/, '');
};

const apiBase =
  normalizeUrl(process.env.REACT_APP_API_URL) ||
  (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV.toLocaleLowerCase() === 'development'
    ? 'http://localhost:3000'
    : 'https://eformprod.ssai.app');

const axiosInstance = axios.create({
  baseURL: `${apiBase}/api/v1/`,
});

axiosInstance.interceptors.request.use((config) => {
  let token = '';
  if (localStorage.getItem('userDetails')) {
    token = JSON.parse(localStorage.getItem('userDetails')).token || '';
    if (token) {
      // Add Authorization header with Bearer token
      config.headers['Authorization'] = `Bearer ${token}`;
    }
  }

  config.params = config.params || {};
  // config.params['auth'] = token;
  return config;
});

export default axiosInstance;
